export default "__VITE_ASSET__ad0b8be4__"